<template>
  <!-- This component is responsible for sending ticket booking details to email -->
  <div>
    <b-modal
      :id="dialogId"
      :ref="dialogId"
      size="xl"
      hide-backdrop
      hide-footer
      no-close-on-esc
      title="Email Booking Details"
    >
      <div class="col-12 h-100">
        <div class="pos-mobile-number pos-email-address">
          <div class="col-12">
            <div class="row centered">
              <div class="mb-4 centered">
                <input
                  v-model="input_email"
                  class="email-address-field pos-email-address"
                  placeholder="Email Address"
                  type="email"
                  required
                  @input="onInputChange"
                  @keydown="validateOnKeyDown"
                />
              </div>
            </div>
          </div>
        </div>
        <Keyboard :input="input_email" @onChange="onChange" @onKeyPress="onKeyPress"/>

        <!-- The bottom section of this email field which shows actions -->
        <div class="text-center mt-4">
          <p>
            We will be sending you the movie ticket booking details on this
            email address.
          </p>
          <button
            class="btn-outline-blue text-black ml-1"
            @click.prevent.stop="clearEmailInput"
          >
            Clear
          </button>
          <button
            class="btn-blue bg-blue text-white ml-1"
            v-on:click="onSendEmail()"
          >
            Send Email
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SimpleKeyboard from "@/components/UIElements/SimpleKeyboard";

export default {
  name: "posEmailBookingDetailsFormDialog",
  props: {
    dialogId: String
  },
  components: {
    Keyboard: SimpleKeyboard,
  },
  data() {
    return {
      email_address: "",
      first_name: "",
      last_name: "",
      customer_id: null,
    }
  },
  watch: {},
  computed: {
    input_email: {
      get() {
        return this.$store.getters.customer_email_address;
      },
      set(value) {
        this.$store.dispatch("updateCustomerEmailAddress", value);
      },
    },
  },
  methods: {
    onChange(input) {
      this.input_email = input;
    },
    onKeyPress(button) {
      console.log("button", button);
    },
    onInputChange(input) {
      this.input_email = input.target.value;
    },
    validateOnKeyDown(e) {
      // Key is not pressed in the input field, it's text is changed by the virtual keyboard. This may never get called.
    },
    clearEmailInput: function () {
      this.input_email = "";
    },
    onSendEmail() {
      if (!this.input_email) {
        this.$toasted.show(
          "Please enter an email address"
        );
      } else {
        // Regex for email validation
        let emailValidationRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        console.log('Validating email');

        let isEmailValid = emailValidationRegex.test(this.input_email);

        console.log(`Is email ${this.input_email} valid: ${isEmailValid}`);

        if (!isEmailValid) {
          this.$toasted.show(
            "Entered email address is invalid"
          );
        } else {
          this.$store.dispatch("sendEmail", {source: "ticket"});
        }
      }
    },
  },
}
</script>

<style scoped>

.pos-email-address {
  max-width: 400px;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.email-address-field {
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-bottom: 6px !important;
  padding-top: 6px !important;
  background: #eaeaed;
  width: 400px;
}

</style>



// WEBPACK FOOTER //
// src/components/Partials/posEmailBookingDetailsFormDialog.vue